<template>
  <div class="signup container">
    <div class="row card-panel" style="padding: 30px;">
      <div class="col-12">
        <div class="row" style="margin-top: 75px">
          <div class="col-12 center">
            <h2 class="teal-text">Authenticating.</h2>
            <p>One moment please...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";

export default {
  name: "Signup",
  data() {
    return {
      email: null,
      password: null,
      alias: null,
      feedback: null,
      success: false,
    };
  },
  methods: {
    finishSignup() {
      console.log(1)
      // Confirm the link is a sign-in with email link.
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        var email = window.localStorage.getItem("emailForSignIn");
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt("Please provide your email for confirmation");
        }
        // The client SDK will parse the code from the link for you.
        firebase
          .auth()
          .signInWithEmailLink(email, window.location.href)
          .then(async function (result) {
             console.log(2)
            // Clear email from storage.
            window.localStorage.removeItem("emailForSignIn");

            var userdb = null;
            var collection = db
              .collection("users")
              .where("email", "==", email);
            var data = await collection.get();

            console.log(data);
            console.log(data.empty);
            if(!data.empty) {
              console.log('Matching document.');
              setTimeout(() => {
                console.log("redirect");
                window.location.href =
                  window.location.protocol + "//" + window.location.host + "/";
              }, 100);
            } else {
              console.log('No matching documents.');
              db.collection("users")
                .add({
                  name: null,
                  email: email,
                  user_id: result.user.uid,
                  permission: 100,
                })
                .then(() => {
                  setTimeout(() => {
                    console.log("redirect");
                    window.location.href =
                      window.location.protocol +
                      "//" +
                      window.location.host +
                      "/";
                  }, 100);
                })
                .catch((err) => {
                  console.log(err);
                  this.feedback = err.message;
                });
            }
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch(function (error) {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          });
      }
    },
  },
  created() {
    this.finishSignup();
  },
};
</script>

<style>
.signup {
  max-width: 400px;
  margin-top: 60px;
}
.signup h2 {
  font-size: 1.4em;
}
.signup .field {
  margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/auth/FinishSignup.vue